// src/router.tsx
import { createSlice, dynamicPage } from "@loopbound-ares/microfrontend";
import { setAresRoute } from "@loopbound-ares/scenes";
import { jsx } from "react/jsx-runtime";
var OrganizationLayout = dynamicPage(() => import("./layout-H4OCJMBS.mjs").then((m) => m.OrganizationLayout));
var OrganizationAlertsPage = dynamicPage(
  () => import("./alerts-BPX76UR2.mjs").then((m) => m.OrganizationAlertsPage)
);
var OrganizationBetasPage = dynamicPage(
  () => import("./betas-XQ7FFAME.mjs").then((m) => m.OrganizationBetasPage)
);
var OrganizationGeneralPage = dynamicPage(
  () => import("./general-ZHWLZCRG.mjs").then((m) => m.OrganizationGeneralPage)
);
var OrganizationHomePage = dynamicPage(
  () => import("./home-EYKNSGMW.mjs").then((m) => m.OrganizationHomePage)
);
var OrganizationInvitesPage = dynamicPage(
  () => import("./invites-YQW6KPMT.mjs").then((m) => m.OrganizationInvitesPage)
);
var OrganizationMembersLayout = dynamicPage(
  () => import("./layout-VNMVSDUC.mjs").then((m) => m.OrganizationMembersLayout)
);
var OrganizationMembersPage = dynamicPage(
  () => import("./members-22YFCPDK.mjs").then((m) => m.OrganizationMembersPage)
);
var OrganizationAuditLogPage = dynamicPage(
  () => import("./audit-logs-MNMA24WR.mjs").then((m) => m.OrganizationAuditLogPage)
);
var OrganizationSecurityLayout = dynamicPage(
  () => import("./layout-5AWLQU7M.mjs").then((m) => m.OrganizationSecurityLayout)
);
var OrganizationSSOPage = dynamicPage(
  () => import("./sso-PI7774ON.mjs").then((m) => m.OrganizationSSOPage)
);
var OrganizationWorkspacesPage = dynamicPage(
  () => import("./workspaces-GENXUBC2.mjs").then((m) => m.OrganizationWorkspacesPage)
);
var OrganizationWorkspacePage = dynamicPage(
  () => import("./products-OGWPRSIC.mjs").then((m) => m.OrganizationWorkspacePage)
);
var OrganizationWorkspaceArtifactsPage = dynamicPage(
  () => import("./artifacts-CM4QX72Z.mjs").then(
    (m) => m.OrganizationWorkspaceArtifactsPage
  )
);
var OrganizationSupportOverviewPage = dynamicPage(
  () => import("./support-U3ZH3J4B.mjs").then((m) => m.OrganizationSupportOverviewPage)
);
var OrganizationSupportChatPage = dynamicPage(
  () => import("./ticket-AZ5WRMDL.mjs").then((m) => m.OrganizationSupportChatPage)
);
var OrganizationBillingPage = dynamicPage(
  () => import("./billing-GSOO7TIJ.mjs").then((m) => m.OrganizationBillingPage)
);
var OrganizationBillingObjectPage = dynamicPage(
  () => import("./[objectId]-FRMCIRHU.mjs").then((m) => m.OrganizationBillingObjectPage)
);
var adminSlice = createSlice(
  [
    {
      path: ":organizationId",
      element: /* @__PURE__ */ jsx(OrganizationLayout, {}),
      children: [
        {
          path: "",
          element: /* @__PURE__ */ jsx(OrganizationHomePage, {})
        },
        {
          path: "general",
          element: /* @__PURE__ */ jsx(OrganizationGeneralPage, {})
        },
        {
          path: "",
          element: /* @__PURE__ */ jsx(OrganizationMembersLayout, {}),
          children: [
            {
              path: "members",
              element: /* @__PURE__ */ jsx(OrganizationMembersPage, {})
            },
            {
              path: "invites",
              element: /* @__PURE__ */ jsx(OrganizationInvitesPage, {})
            }
          ]
        },
        {
          path: "",
          element: /* @__PURE__ */ jsx(OrganizationSecurityLayout, {}),
          children: [
            {
              path: "audit-logs",
              element: /* @__PURE__ */ jsx(OrganizationAuditLogPage, {})
            },
            {
              path: "sso",
              element: /* @__PURE__ */ jsx(OrganizationSSOPage, {})
            }
          ]
        },
        {
          path: "workspaces",
          element: /* @__PURE__ */ jsx(OrganizationWorkspacesPage, {})
        },
        {
          path: "alerts",
          element: /* @__PURE__ */ jsx(OrganizationAlertsPage, {})
        },
        {
          path: "betas",
          element: /* @__PURE__ */ jsx(OrganizationBetasPage, {})
        },
        {
          path: "workspaces/:workspaceId/:product",
          element: /* @__PURE__ */ jsx(OrganizationWorkspacePage, {})
        },
        {
          path: "workspaces/:workspaceId/:product/artifacts",
          element: /* @__PURE__ */ jsx(OrganizationWorkspaceArtifactsPage, {})
        },
        {
          path: "support",
          element: /* @__PURE__ */ jsx(OrganizationSupportOverviewPage, {})
        },
        {
          path: "support/tickets/:ticketId",
          element: /* @__PURE__ */ jsx(OrganizationSupportChatPage, {})
        },
        {
          path: "billing",
          element: /* @__PURE__ */ jsx(OrganizationBillingPage, {})
        },
        {
          path: "billing/object/:objectId",
          element: /* @__PURE__ */ jsx(OrganizationBillingObjectPage, {})
        }
      ]
    }
  ],
  {
    onInit: (prefix) => {
      setAresRoute("organization_adminFull", (o) => `/${prefix}/${o.organizationSlug}`);
      setAresRoute("organization_settings_home", (o) => `/${prefix}/${o.organizationSlug}`);
      setAresRoute(
        "organization_settings_general",
        (o) => `/${prefix}/${o.organizationSlug}/general`
      );
      setAresRoute(
        "organization_settings_invites",
        (o) => `/${prefix}/${o.organizationSlug}/invites`
      );
      setAresRoute(
        "organization_settings_members",
        (o) => `/${prefix}/${o.organizationSlug}/members`
      );
      setAresRoute(
        "organization_support_home",
        (o) => `/${prefix}/${o.organizationSlug}/support`
      );
      setAresRoute(
        "organization_support_ticket",
        (o) => `/${prefix}/${o.organizationSlug}/support/tickets/${o.ticketId}`
      );
      setAresRoute(
        "organization_settings_workspace",
        (o) => `/${prefix}/${o.organizationSlug}/workspaces/${o.workspaceSlug}/${o.product}`
      );
      setAresRoute(
        "organization_settings_billing",
        (o) => `/${prefix}/${o.organizationSlug}/billing`
      );
      setAresRoute(
        "organization_settings_billing_object",
        (o) => `/${prefix}/${o.organizationSlug}/billing/object/${o.billingObjectId}`
      );
    }
  }
);
export {
  adminSlice
};
//# sourceMappingURL=index.mjs.map